import { Align, Color, TypographyAlign, TypographyColor } from "../components/typography"
import {
    Background,
    BackgroundColor,
    Container,
    Spacer,
    SpacerVariant,
    backgroundOptions,
    spacerOptions,
} from "../components/layout"
import React, { useState } from "react"
import { Repeater, types } from "react-bricks/frontend"
import Typography, { TypographyElement } from "../Typography"

interface FAQsProps {
    background: { color: BackgroundColor } | BackgroundColor
    allClosedOnDefault?: boolean
    text: TypographyElement[]
    spacerTop: boolean
    spacerBottom: boolean
    variantTop?: SpacerVariant
    variantBottom?: SpacerVariant
}

const FAQs: types.Brick<FAQsProps> = ({
    background,
    allClosedOnDefault,
    spacerTop,
    spacerBottom,
    variantTop,
    variantBottom,
}) => {
    const [isOpen, setIsOpen] = useState(allClosedOnDefault ? undefined : 0)

    const bgColor = typeof background === "object" ? background.color : background

    return (
        <Background color={bgColor}>
            <Container className="sm:px-20 md:px-28 lg:px-40 xl:max-w-[1008px] xl:px-0">
                <Spacer variant={!spacerTop ? SpacerVariant.None : variantTop} />
                <Color
                    color={
                        bgColor === BackgroundColor.Green || bgColor === BackgroundColor.DarkBlumine
                            ? TypographyColor.White
                            : TypographyColor.Darkgrey
                    }
                >
                    <Align align={TypographyAlign["Center + mobile left"]}>
                        <Typography block="copytext-small" allowList={["h3", "h4", "bold", "small", "sup", "link"]} />
                    </Align>
                    <Spacer variant={SpacerVariant.Small} />
                    <ul>
                        <Repeater propName="repeater" itemProps={{ bgColor: bgColor, setIsOpen, isOpen }} />
                    </ul>
                </Color>
                <Spacer variant={!spacerBottom ? SpacerVariant.None : variantBottom} />
            </Container>
        </Background>
    )
}

FAQs.schema = {
    name: "FAQs",
    label: "FAQs",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/FAQs.png`,
    repeaterItems: [
        {
            name: "repeater",
            items: [
                {
                    type: "FAQ",
                    label: "FAQ",
                    min: 1,
                },
            ],
        },
    ],
    sideEditProps: [
        {
            name: "background",
            label: "Background",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: backgroundOptions,
                display: types.OptionsDisplay.Color,
            },
        },
        {
            name: "allClosedOnDefault",
            label: "All closed on default",
            type: types.SideEditPropType.Boolean,
        },
        {
            groupName: "Spacer",
            props: [
                {
                    name: "spacerTop",
                    label: "Spacer Top",
                    type: types.SideEditPropType.Boolean,
                },
                {
                    name: "variantTop",
                    label: "Spacer Variant",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptions,
                        display: types.OptionsDisplay.Select,
                    },
                    show: props => props.spacerTop === true,
                },
                {
                    name: "spacerBottom",
                    label: "Spacer Bottom",
                    type: types.SideEditPropType.Boolean,
                },
                {
                    name: "variantBottom",
                    label: "Spacer Variant",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptions,
                        display: types.OptionsDisplay.Select,
                    },
                    show: props => props.spacerBottom === true,
                },
            ],
        },
    ],
    getDefaultProps: (): FAQsProps => ({
        background: { color: BackgroundColor.White },
        allClosedOnDefault: false,
        text: [
            {
                type: "h3",
                children: [
                    {
                        text: "Lorem ipsum dolor sit amet",
                    },
                ],
            },
            {
                type: "paragraph",
                children: [
                    {
                        text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc placerat sagittis faucibus.",
                    },
                ],
            },
        ],
        spacerTop: true,
        spacerBottom: true,
        variantTop: SpacerVariant.Base,
        variantBottom: SpacerVariant.Base,
    }),
}

export default FAQs
